(function () {
  "use strict";

  var PENDING_KEY = "kuji_pending_lottery_collection";
  var COLLECTION_PAGE = "/pages/kuji-collection";
  var syncRetryTimer = null;
  var bannerObserver = null;

  function apiBase() {
    return (
      window.LOTTERY_API_BASE || "https://home-5017198992.app-ionos.space"
    ).replace(/\/+$/, "");
  }

  function customerId() {
    var raw = window.KUJI_CUSTOMER_ID;
    if (
      raw === null ||
      raw === undefined ||
      raw === "" ||
      raw === "null" ||
      raw === "undefined"
    ) {
      return null;
    }
    return String(raw);
  }

  function syncStorageKey(orderId, productId) {
    return "kuji_lottery_sync_v2_" + orderId + "_" + productId;
  }

  function loginUrl() {
    return (
      "/customer_authentication/login?return_to=" +
      encodeURIComponent(COLLECTION_PAGE)
    );
  }

  function getBanner() {
    return document.getElementById("kujiCollectionBanner");
  }

  function showBanner(mode) {
    var banner = getBanner();
    if (!banner) return;

    var inner = banner.querySelector(".kuji-collection-banner__inner");
    if (!inner) return;

    banner.classList.remove("is-success");
    if (mode === "logged-in") {
      banner.classList.add("is-success");
      inner.innerHTML =
        '<span class="kuji-collection-banner__text">Deine Gewinne wurden zu deiner Sammlung hinzugefügt.</span>' +
        '<a class="kuji-collection-banner__link" href="' +
        COLLECTION_PAGE +
        '">Zur Sammlung</a>';
    } else {
      inner.innerHTML =
        '<span class="kuji-collection-banner__text">Melde dich an oder registriere dich, um deine Gewinne zur Sammlung hinzuzufügen.</span>' +
        '<a class="kuji-collection-banner__link" href="' +
        loginUrl() +
        '">Anmelden / Registrieren</a>';
    }

    banner.classList.add("is-show");
    // Inline style beats any stylesheet race / cache
    banner.style.display = "block";
  }

  function stashPending(orderId, productId) {
    try {
      sessionStorage.setItem(
        PENDING_KEY,
        JSON.stringify({
          order_id: String(orderId),
          product_id: String(productId),
        }),
      );
      localStorage.setItem("kuji_login_return", COLLECTION_PAGE);
    } catch (_) {}
  }

  function readPending() {
    try {
      var raw = sessionStorage.getItem(PENDING_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (_) {
      return null;
    }
  }

  function clearPending() {
    try {
      sessionStorage.removeItem(PENDING_KEY);
      localStorage.removeItem("kuji_login_return");
    } catch (_) {}
  }

  function orderAndProductIds() {
    var orderEl = document.getElementById("neworderid");
    var productEl = document.getElementById("neworderidpid");
    var params = new URLSearchParams(window.location.search);
    var orderId = (orderEl && orderEl.value) || params.get("oid") || "";
    var productId = (productEl && productEl.value) || params.get("pid") || "";
    return { orderId: orderId, productId: productId };
  }

  function hasPrizeOverview() {
    var grid = document.getElementById("prizeOverviewSec1");
    if (!grid) return false;
    return !!(
      grid.querySelector(".prizeOverViewBx") || grid.children.length > 0
    );
  }

  function isStep4Active() {
    var step4 = document.querySelector(".step.step-4");
    return !!(step4 && step4.classList.contains("active"));
  }

  function isCollectionPage() {
    return window.location.pathname.indexOf("/pages/kuji-collection") === 0;
  }

  function revealBanner(synced) {
    if (!(isCollectionPage() || hasPrizeOverview())) return;
    if (!customerId()) {
      showBanner("logged-out");
      return;
    }
    if (synced) showBanner("logged-in");
  }

  function forceBannerIfStep4Ready() {
    if (!isStep4Active()) return false;
    if (!hasPrizeOverview()) return false;
    if (!customerId()) {
      showBanner("logged-out");
      return true;
    }
    var ids = orderAndProductIds();
    var synced = false;
    try {
      synced =
        sessionStorage.getItem(syncStorageKey(ids.orderId, ids.productId)) ===
        "done";
    } catch (_) {}
    if (synced) showBanner("logged-in");
    return synced;
  }

  async function syncLotteryCollection(orderId, productId, options) {
    options = options || {};
    if (!orderId || !productId) return false;

    var allowWithoutOverview = !!options.allowWithoutOverview;
    if (!allowWithoutOverview && !hasPrizeOverview()) return false;

    var cid = customerId();
    var doneKey = syncStorageKey(orderId, productId);

    if (sessionStorage.getItem(doneKey) === "done") {
      revealBanner(true);
      return true;
    }

    if (!cid) {
      stashPending(orderId, productId);
      revealBanner();
      return false;
    }

    try {
      var body = new URLSearchParams({
        customer_id: cid,
        order_id: String(orderId),
        product_id: String(productId),
      });
      var res = await fetch(apiBase() + "/api/kuji/collection/sync-lottery", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      var data = null;
      try {
        data = await res.json();
      } catch (_) {}

      var saved = !!(
        res.ok &&
        data &&
        data.status &&
        (Number(data.total) > 0 ||
          Number(data.added) > 0 ||
          Number(data.skipped) > 0)
      );
      if (saved) {
        sessionStorage.setItem(doneKey, "done");
        clearPending();
        document.dispatchEvent(
          new CustomEvent("kuji-lottery-collection-synced", {
            detail: { added: data.added, total: data.total },
          }),
        );
      }

      revealBanner(saved);
      return saved;
    } catch (_) {
      revealBanner();
      return false;
    }
  }

  async function resumePendingLotteryCollection() {
    var pending = readPending();
    if (pending && pending.order_id && pending.product_id) {
      await syncLotteryCollection(pending.order_id, pending.product_id, {
        allowWithoutOverview: !!customerId(),
      });
      return;
    }

    if (!customerId()) return;

    var ids = orderAndProductIds();
    if (ids.orderId && ids.productId) {
      await syncLotteryCollection(ids.orderId, ids.productId);
    }
  }

  function maybeSyncFromDom() {
    var ids = orderAndProductIds();
    if (!ids.orderId || !ids.productId) return;

    // Retry a few times — refresh→step4 often calls maybeSync before prize cards paint
    var attempts = 0;
    var maxAttempts = 15;

    if (syncRetryTimer) {
      clearInterval(syncRetryTimer);
      syncRetryTimer = null;
    }

    function tryOnce() {
      attempts += 1;
      if (hasPrizeOverview() || allowAttemptWithoutOverview()) {
        syncLotteryCollection(ids.orderId, ids.productId, {
          allowWithoutOverview: allowAttemptWithoutOverview(),
        });
        forceBannerIfStep4Ready();
        if (hasPrizeOverview() || attempts >= maxAttempts) {
          if (syncRetryTimer) {
            clearInterval(syncRetryTimer);
            syncRetryTimer = null;
          }
        }
        return;
      }
      if (attempts >= maxAttempts && syncRetryTimer) {
        clearInterval(syncRetryTimer);
        syncRetryTimer = null;
      }
    }

    function allowAttemptWithoutOverview() {
      // Only skip overview gate when we already know sync completed this session
      try {
        return (
          sessionStorage.getItem(syncStorageKey(ids.orderId, ids.productId)) ===
          "done"
        );
      } catch (_) {
        return false;
      }
    }

    tryOnce();
    syncRetryTimer = setInterval(tryOnce, 250);
  }

  function watchPrizeOverview() {
    var grid = document.getElementById("prizeOverviewSec1");
    if (!grid || bannerObserver) return;

    bannerObserver = new MutationObserver(function () {
      if (!hasPrizeOverview()) return;
      forceBannerIfStep4Ready();
      maybeSyncFromDom();
    });
    bannerObserver.observe(grid, { childList: true, subtree: true });
  }

  function onStep4Shown() {
    watchPrizeOverview();
    forceBannerIfStep4Ready();
    maybeSyncFromDom();
  }

  window.kujiLotteryCollection = {
    sync: syncLotteryCollection,
    resume: resumePendingLotteryCollection,
    maybeSync: maybeSyncFromDom,
    onStep4: onStep4Shown,
    forceBanner: forceBannerIfStep4Ready,
  };

  function boot() {
    watchPrizeOverview();
    resumePendingLotteryCollection();
    if (isStep4Active()) onStep4Shown();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
